import { Card, CardBody, Col, Container } from 'reactstrap'
import { Carts } from '../../../../Utils/Constants'
import CartData from './CartData'
import CommonCardHeader from '../../../../Utils/CommonComponents/CommonCardHeader/CommonCardHeader'

const CartContainer = () => {
  return (
    <Container fluid>
        <Col sm="12">
          <Card>
            <CommonCardHeader title={Carts} />
            <CardBody>
              <CartData />
            </CardBody>
          </Card>
        </Col>
    </Container>
  )
}

export default CartContainer